exports.server = "https://grand-mern-e-commerce-app.vercel.app";
